import './validate/validate.directive';

import './inner-html/inner-html.directive';

import './custom-select/custom-select.directive';

import './upload-image-preview/upload-image-preview.directive';

import './date-picker/date-picker.directive';

import './date-picker-range/date-picker-range.directive';

import './document/document.directive';

import './equals/equals.directive';

import './hour/hour.directive';

import './date/date.directive';

import './date-same-or-before/date-same-or-before.directive';

import './date-after/date-after.directive';

import './date-same-or-after/date-same-or-after.directive';

import './checklist/checklist.directive';

import './item-children/item-children.directive';

import './mask/mask.directive';

import './char/char.directive';

import './link/link.directive';

import './stop-propagation/stop-propagation.directive';

import './indeterminate/indeterminate.directive';

import './check-all/check-all.directive';

import './tags/tags.directive';

import './select/select.directive';

import './custom-select-lazy-load/custom-select-lazy-load.directive';

import './custom-select-lazy-load-inss/custom-select-lazy-load-inss.directive';

import './custom-select-lazy-load-params/custom-select-lazy-load-params.directive';

import './highlight/highlight.directive';

import './scrollmax/scrollmax.directive';

import './scroll-top-button/scroll-top-button.directive';

import './inline-datepicker/inline-datepicker.directive';

import './submenu/submenu.directive';

import './air-datepicker/air-datepicker.directive';

import './air-datepicker/air-datepicker-range.directive';

import './group-permission/group-permission.directive';

import './min-length/min-length.directive';

import './min-value/min-value.directive';

import './custom-select-search-history/custom-select-search-history.directive';

import './text-editor/text-editor.directive';

import './text-editor-edit/text-edit-editor.directive';

import './input-types/input-types.directive';

import './modal-send-email/modal-send-email.directive';

import './cpf-cnpj-validate-mask/cpf-cnpj-validate-mask.directive';

import './qr-code/qr-code.directive';

import './copy-clipboard/copy-clipboard.directive';

import './tooltip-ellipsis/tooltip-ellipsis.directive';

import './svg-image/doc-svg/doc-svg.directive';
import './svg-image/excel-svg/excel-svg.directive';
import './svg-image/pdf-svg/pdf-svg.directive';
import './svg-image/xml-svg/xml-svg.directive';

import './svg-image/sync-svg/sync-svg.directive';
import './svg-image/resync-svg/resync-svg.directive';
